import { render, staticRenderFns } from "./ContactNotesWithLsAndAs.vue?vue&type=template&id=65acd15f&scoped=true&"
import script from "./ContactNotesWithLsAndAs.vue?vue&type=script&lang=js&"
export * from "./ContactNotesWithLsAndAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65acd15f",
  null
  
)

export default component.exports